import { findGeomNode } from "./geomSelection";

export function resolveScaleTargetFromSelection({
  selection,
  bodies,
  findGeomSceneObjectForGizmo,
}) {
  const bodiesNow = bodies || {};

  if (selection?.selectedGeom) {
    const match = findGeomNode(bodiesNow, selection.selectedGeom);
    const geom = match?.geom || null;
    if (!match || !geom) return null;

    return {
      kind: "geom",
      bodyUuid: match.bodyUuid,
      geomId: String(geom.uuid),
      geomKind: String(geom.kind || (geom.mesh ? "mesh" : "sphere")),
      meshUuid: geom.mesh || null,
      object: findGeomSceneObjectForGizmo?.(match.bodyUuid, geom.uuid, geom.mesh || null) || null,
    };
  }

  if (selection?.selectedMesh) {
    const meshUuid = String(selection.selectedMesh);
    for (const [bodyUuid, body] of Object.entries(bodiesNow)) {
      const geom = Array.isArray(body?.geoms)
        ? body.geoms.find(
            (entry) => entry && entry.visualOnly === true && String(entry.mesh || "") === meshUuid
          )
        : null;
      if (!geom) continue;

      return {
        kind: "mesh",
        meshUuid,
        bodyUuid,
        object: findGeomSceneObjectForGizmo?.(bodyUuid, geom.uuid, meshUuid) || null,
      };
    }
  }

  return null;
}

export function getScaleSelectionTargetFromObject(
  obj,
  { getCollisionTarget, getVisualGeomTarget }
) {
  const collisionTarget = getCollisionTarget?.(obj);
  if (collisionTarget?.name) {
    return { targetType: "geom", candidate: collisionTarget };
  }

  const visualGeomTarget = getVisualGeomTarget?.(obj);
  if (visualGeomTarget?.name) {
    return {
      targetType: "mesh",
      candidate: {
        ...visualGeomTarget,
        selectionType: "geom",
      },
    };
  }

  return null;
}

export function pickScaleSelectionTargetFromIntersects(
  validIntersects,
  { getCollisionTarget, getVisualGeomTarget }
) {
  if (!Array.isArray(validIntersects)) return null;

  for (const intersect of validIntersects) {
    const target = getScaleSelectionTargetFromObject(intersect?.object, {
      getCollisionTarget,
      getVisualGeomTarget,
    });
    if (target) return target;
  }

  return null;
}
